module.exports = __webpack_public_path__ + "img/quote.76bde9de.png";